import React from 'react'
import numberbeautify from '../../utils/numberbeautify';
import money_rounding from '../../utils/money_rounding';
import iqd_rounding from '../../utils/iqd_rounding';
import moment from 'moment/moment';

const Expensedetailmodal = props => {
  return (
    <>
      {props.show ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none p-4">
            <div className="relative my-2 sm:my-4 md:my-6 mx-auto w-full sm:w-2/3 md:w-3/4 lg:w-2/3">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/* Header */}
                <div className="flex items-center justify-between p-3 sm:p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                    وردەکاری خەرجی
                  </h3>
                  <button
                    className="p-1 ml-auto text-black opacity-80 text-2xl sm:text-3xl leading-none font-semibold"
                    onClick={() => props.setshow(false)}
                  >
                    <span className="block">X</span>
                  </button>
                </div>

                {/* Body */}
                <div className="relative p-4 sm:p-6 flex-auto">
                  <div className="overflow-x-auto">
                    <div className="inline-block min-w-full">
                      <div className="shadow-md rounded-lg overflow-hidden">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead>
                            <tr>
                              <th className="px-3 sm:px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                بڕی خەرجی
                              </th>
                              <th className="hidden sm:table-cell px-3 sm:px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                تێبینی
                              </th>
                              <th className="px-3 sm:px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                بەروار
                              </th>
                              <th className="hidden md:table-cell px-3 sm:px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                یوزەر
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {props.expense.map((lis) => (
                              <tr 
                                key={lis.expense_id}
                                className="hover:bg-gray-50 transition-colors duration-200"
                              >
                                <td className="px-3 sm:px-5 py-3 sm:py-4 whitespace-nowrap text-sm text-gray-900">
                                  {numberbeautify(iqd_rounding(lis.expense_amount))} IQD
                                </td>
                                <td className="hidden sm:table-cell px-3 sm:px-5 py-3 sm:py-4 whitespace-nowrap text-sm text-gray-900">
                                  {lis.expense_note}
                                </td>
                                <td className="px-3 sm:px-5 py-3 sm:py-4 whitespace-nowrap text-sm text-gray-900">
                                  {moment(lis.expense_date).format('YYYY-MM-DD')}
                                </td>
                                <td className="hidden md:table-cell px-3 sm:px-5 py-3 sm:py-4 whitespace-nowrap text-sm text-gray-900">
                                  {lis.user_name}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-end p-3 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 
                      font-bold uppercase text-sm px-4 sm:px-6 py-2 sm:py-3 rounded 
                      shadow hover:shadow-lg transition-all duration-150"
                    onClick={() => props.setshow(false)}
                  >
                    داخستن
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  )
}

export default Expensedetailmodal